import React from "react";

export const ExpandLink = ({title, isOpen, clickHandler, className}) => {
  const iconClass = `zmdi zmdi-chevron-${isOpen ? 'up' : 'down'}`;
  return (
    <div onClick={clickHandler} className={`${className} text-primary c-pointer`}>{title} <i className={iconClass}></i></div>
  )
}